<!--
 * @Author: xuchen
 * @Date: 2020-03-10 14:30:52
 * @Desc: 条件筛选
 -->
<template>
  <div class="filter-tags-container">
    <!-- TODO -->
    <div class="filter-item-container">
      <div class="filter-item-tit">区域</div>
      <h-tree-select
        ref="asyncTree"
        v-model="selectRegionData"
        :tree-data="regionData"
        show-checkbox
        :check-strictly="true"
        simple-data
        node-key="id"
        parent-key="pId"
        :show-search="false"
        popper-class="filter-region-popper"
      />
    </div>
    <div v-for="item in dataProvider" :key="item.labelCode" class="filter-item-container">
      <div class="filter-item-tit">{{ item.labelType }}</div>
      <div class="flex tag-container">
        <div
          :ref="`div_${item.labelCode}`"
          :class="[
            'flex-1 flex flex-wrap',
            { 'less-filter-tag-container': !openedLabelTypes.includes(item.labelCode) }
          ]"
        >
          <div
            :class="['filter-item-content', { actived: !selectedKeys[item.labelCode].length }]"
            @click="handleSelectAllTag(item.labelCode)"
          >
            不限
          </div>
          <div
            v-for="tag in item.list"
            :key="tag.labelId"
            :class="[
              'filter-item-content',
              {
                actived: selectedKeys[item.labelCode].includes(tag.labelId)
              }
            ]"
            @click="handleSelectTag(item.labelCode, tag.labelId)"
          >
            {{ tag.labelName }}
          </div>
        </div>
        <div
          v-if="isNeedShowMore[item.labelCode]"
          class="flex items-start filter-item-more"
          @click="handleOpen(item.labelCode)"
        >
          <span>{{ openedLabelTypes.includes(item.labelCode) ? '收起' : '更多' }}</span>
          <i
            :class="[
              'arrow-icon',
              openedLabelTypes.includes(item.labelCode)
                ? 'h-icon-angle_up_sm'
                : 'h-icon-angle_down_sm'
            ]"
          ></i>
        </div>
      </div>
    </div>
    <separate />
    <div class="flex">
      <el-button type="primary" @click="submitFilter">查询</el-button>
      <el-button @click="resetFilter">重置</el-button>
    </div>
  </div>
</template>

<script>
import Separate from '@/components/Separate/Separate'

export default {
  name: 'FilterTags',
  components: {
    Separate
  },
  props: {
    defaultSelectedKeys: {
      // 选中的标签
      type: Array,
      default: () => []
    },
    dataProvider: {
      // 标签集合,例如：[{ labelType: 'xxx', list: [{ labelId: 'xx', labelName: 'xx'}] }]
      type: Array,
      default: () => []
    },
    regionData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedKeys: {}, // 选中的标签, 例如 { ’类目‘: [1, 2] }
      openedLabelTypes: [], // 展开的类目
      selectRegionData: [], // 选中的区域数据
      isNeedShowMore: {} // 用于储存判断是否显示更多
    }
  },
  watch: {
    // 同步选中项
    defaultSelectedKeys(keys) {
      const selectedKeys = {}
      this.dataProvider.forEach(i => {
        selectedKeys[i.labelCode] = []
        i.list.forEach(j => {
          // 找到已选中的
          if (keys.includes(j.labelId)) {
            selectedKeys[i.labelCode].push(j.labelId)
          }
        })
      })
      this.selectedKeys = selectedKeys
    },
    defaultSelectedRegion(key) {
      this.selectRegionData = key
    },

    /**
     * @author xuchen
     * @date 2020-02-27 21:35:56
     * @desc 初始化选中标签
     */
    dataProvider: {
      handler(data = []) {
        data.forEach(i => {
          this.selectedKeys[i.labelCode] = []
        })
      },
      immediate: true
    }
  },
  methods: {
    /**
     * @author xuchen
     * @date 2020-01-20 16:36:33
     * @desc 选择标签
     */
    handleSelectTag(labelCode, key) {
      const { selectedKeys } = this
      const category = [...selectedKeys[labelCode]]

      // 类目内已经存在当前标签
      if (category.includes(key)) {
        const matchIdx = category.indexOf(key)
        category.splice(matchIdx, 1)
      } else {
        category.push(key)
      }
      this.selectedKeys = {
        ...this.selectedKeys,
        [labelCode]: category
      }
    },

    /**
     * @author xuchen
     * @date 2020-02-27 21:43:09
     * @desc 全选
     */
    handleSelectAllTag(labelCode) {
      this.selectedKeys = {
        ...this.selectedKeys,
        [labelCode]: []
      }
    },

    /**
     * @author xuchen
     * @date 2020-02-27 22:17:36
     * @desc 处理展开逻辑
     */
    handleOpen(labelCode) {
      const matchIdx = this.openedLabelTypes.indexOf(labelCode)

      // 已经展开过
      if (matchIdx !== -1) {
        this.openedLabelTypes.splice(matchIdx, 1)
      } else {
        this.openedLabelTypes.push(labelCode)
      }
    },

    /**
     * @author xuchen
     * @date 2020-01-20 16:36:46
     * @desc 点击确定
     */
    submitFilter() {
      let keys = []
      Object.keys(this.selectedKeys).forEach(i => {
        keys = [...keys, ...this.selectedKeys[i]]
      })
      this.$emit('submit', {
        keys,
        unresolveKeys: this.selectedKeys,
        regionCodeList: this.selectRegionData
      })
    },

    /**
     * @author xuchen
     * @date 2020-01-20 16:36:58
     * @desc 点击重置
     */
    resetFilter() {
      const keys = {}
      this.dataProvider.forEach(i => {
        keys[i.labelCode] = []
      })
      this.selectedKeys = keys
      this.selectRegionData = []
      this.$emit('reset')
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-04-01 16:13:41
     * @Desc: 更新显示更多按钮状态
     */
    changeMoreBtnDisplay() {
      this.$nextTick(() => {
        const curStatus = {}
        this.dataProvider.forEach(i => {
          curStatus[i.labelCode] = this.isShowMore(`div_${i.labelCode}`)
        })
        this.isNeedShowMore = curStatus
      })
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-04-01 16:13:44
     * @Desc: 根据父子宽度判断是否需要显示更多
     */
    isShowMore(elmRef) {
      const elm = this.$refs[elmRef][0]
      const parentWidth = elm.clientWidth
      const childrenWidth = this.calculateChildrenWidth(elm)
      return parentWidth < childrenWidth
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-04-01 16:13:47
     * @Desc: 计算子节点宽度
     */
    calculateChildrenWidth(elm) {
      const children = elm.children
      let width = 0
      for (let index = 0; index < children.length; index++) {
        const child = children[index]
        width += child.clientWidth
      }
      return width
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-tags-container {
  padding: 4px 24px 24px;
  .filter-item-container {
    padding-bottom: 15px;
  }
  .filter-item-more {
    padding-top: 2px;
    cursor: pointer;
    color: #2196f3;
    .arrow-icon {
      font-size: 20px;
    }
    &:hover {
      opacity: 0.8;
    }
  }

  .filter-item-tit {
    padding-bottom: 14px;
    color: rgba(0, 0, 0, 0.7);
  }
  .filter-item-content {
    padding: 2px 8px;
    line-height: 20px;
    margin-right: 8px;
    margin-bottom: 8px;
    border-radius: 2px;
    background: rgba(0, 0, 0, 0.04);
    color: rgba(0, 0, 0, 0.7);
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
    &.actived {
      background: #e72528;
      color: #fff;
    }
  }
  .less-filter-tag-container {
    height: 32px;
    overflow: hidden;
  }
}
</style>

<style lang="scss">
.filter-region-popper {
  z-index: 10000 !important;
}
</style>
